import { render, staticRenderFns } from "./FSDialog.vue?vue&type=template&id=b4dde444&scoped=true&"
import script from "./FSDialog.vue?vue&type=script&lang=js&"
export * from "./FSDialog.vue?vue&type=script&lang=js&"
import style0 from "./FSDialog.vue?vue&type=style&index=0&id=b4dde444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dde444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
})
